import { useEffect, useState } from 'react';

import BlackFridayLettering from '../../../assets/black-friday-2026-lettering.png';
import { MLABS_TRANSLATOR_ON_CHANGE_LANGUAGE } from '../../../constants';
import useCore from '../../../hooks/useCore';
import { getLanguage } from '../../../services/auth';
import { transcodeLanguage } from '../../../utils/language';
import { useReactNativeWebView } from '../../../utils/isReactNativeWebView';
import bannerBlackFridayData from './banner-black-friday.json';

import {
  BannerWrapper,
  Lettering,
  ContainerTexts,
  Title,
  Highlight,
  Description,
  DescriptionLine,
  Offer,
  OfferHighlight,
} from './styles';

const FEATURE_KEY = 'black_friday';

const BlackFriday = () => {
  const [language, setLanguage] = useState(() => transcodeLanguage(getLanguage()));
  const [featureIsActive, setFeatureIsActive] = useState(false);
  const { fetchFeature } = useCore();
  const inWebView = useReactNativeWebView();

  useEffect(() => {
    const onChangeLanguage = (event) => {
      setLanguage(transcodeLanguage(event.detail.language));
    };

    window.addEventListener(MLABS_TRANSLATOR_ON_CHANGE_LANGUAGE, onChangeLanguage);

    return () => window.removeEventListener(MLABS_TRANSLATOR_ON_CHANGE_LANGUAGE, onChangeLanguage);
  }, []);

  useEffect(() => {
    let mounted = true;

    const getBlackFridayFeature = async () => {
      try {
        const response = await fetchFeature(FEATURE_KEY, true);
        const isActive = !!response?.data?.some(
          (item) => item.attributes.key === FEATURE_KEY && item.attributes.active,
        );

        if (mounted) setFeatureIsActive(isActive);
      } catch (_) {
        if (mounted) setFeatureIsActive(false);
      }
    };

    getBlackFridayFeature();

    return () => {
      mounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const bannerData = bannerBlackFridayData[language];

  if (!featureIsActive || !bannerData || inWebView) return null;

  return (
    <BannerWrapper id="banner" data-testid="banner-black-friday">
      <Lettering src={BlackFridayLettering} alt={bannerData.letteringAlt} />

      <ContainerTexts>
        <Title>
          {bannerData.title} <Highlight>{bannerData.titleHighlight}</Highlight>
        </Title>
        <Description>
          <DescriptionLine>{bannerData.description}</DescriptionLine>
          <Offer>
            {bannerData.offer} <OfferHighlight>{bannerData.offerHighlight}</OfferHighlight>
          </Offer>
        </Description>
      </ContainerTexts>
    </BannerWrapper>
  );
};

export default BlackFriday;
